export const SET_TOKEN_VALIDATION_STATE = 'SET_TOKEN_VALIDATION_STATE';
export const FILL_AUTH_SERVICE_POINT_DATA = 'FILL_AUTH_SERVICE_POINT_DATA';
export const TOGGLE_WAITING_FOR_AUTH_SERVICE_POINT_DATA = 'TOGGLE_WAITING_FOR_AUTH_SERVICE_POINT_DATA';
export const SET_STATE_FOR_WAITING_FOR_AUTH_SERVICE_POINT_DATA = 'SET_STATE_FOR_WAITING_FOR_AUTH_SERVICE_POINT_DATA';
export const SET_AFTER_AUTHORIZATION_URL = 'SET_AFTER_AUTHORIZATION_URL';
export const SET_FORM_TYPE = 'SET_FORM_TYPE';



// WEBPACK FOOTER //
// ./src/store/modules/authServicesPoints/mutations-types.js